module.exports = __webpack_public_path__ + "img/book-cover.17d1a8b3.png";